import { queryOptions, useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getAssignableOrdersForInvoice,
	getInvoiceRecipientSummary,
	indexProcessedInvoices,
	indexProjectsInvoices,
	showInvoice,
} from "~/modules/billing/api/processedInvoice/processedInvoiceApiDispatchers.ts";


export const INVOICES_BASE_QUERY_KEY = "invoices";

export const ALL_PROCESSED_INVOICES_QUERY_KEY = [INVOICES_BASE_QUERY_KEY, "in-period"];

export const ASSIGNABLE_ORDERS_FOR_INVOICE_QUERY_KEY = (invoiceId: string) => [INVOICES_BASE_QUERY_KEY, "assignable-orders", { invoiceId }];

export const useAssignableOrdersForInvoice = (invoiceId: string) => {
	return useQuery({
		queryKey: ASSIGNABLE_ORDERS_FOR_INVOICE_QUERY_KEY(invoiceId),
		queryFn: () => getAssignableOrdersForInvoice(invoiceId).then(getDataFromResponse),
		enabled: !!invoiceId,
	});
};

export const invoiceRecipientQuery = (invoiceId: string) => queryOptions({
	queryKey: ["invoice-recipient-summary", { invoiceId }],
	queryFn: () => getInvoiceRecipientSummary(invoiceId).then(getDataFromResponse),
	enabled: !!invoiceId,
});

export const processedInvoiceQueries = {
	baseKey: [INVOICES_BASE_QUERY_KEY],
	byProject: (projectId: string) => queryOptions({
		queryKey: [...processedInvoiceQueries.baseKey, "by-project", projectId],
		queryFn: () => indexProjectsInvoices(projectId).then(getDataFromResponse),
	}),
	details: (invoiceId: string) => queryOptions({
		queryKey: [...processedInvoiceQueries.baseKey, invoiceId],
		queryFn: () => showInvoice({ invoiceId }).then(getDataFromResponse),
	}),
	inPeriod: ({ dateFrom, dateTo, includeAllOverdue = false }: {
		dateFrom: string,
		dateTo: string,
		includeAllOverdue: boolean
	}) =>
		queryOptions({
			queryKey: [...processedInvoiceQueries.baseKey, "in-period", dateFrom, dateTo, includeAllOverdue],
			queryFn: () => indexProcessedInvoices({ dateFrom, dateTo, includeAllOverdue }).then(getDataFromResponse),
		}),
};